import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { menus } from "data/actions";

class MobileMenu extends Component {
  render() {
    const cls = !this.props.open ? "" : "mobilenav--" + this.props.open;
    return (
      <nav id="mobilenav">
        <a className="mobilenav__toggle" onClick={this.props.actions.toggleLeft}>
          ☰
        </a>
        <img src="/images/logo.png" alt="" />
        <a className="mobilenav__toggle" onClick={this.props.actions.toggleRight}>
          ▼
        </a>
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    open: state.open
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators({ ...menus }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch)(MobileMenu);



// WEBPACK FOOTER //
// ./src/pages/MobileMenu.jsx